<ion-card >
  <ion-card-header>
    <ion-card-title>Delivery Back Choice</ion-card-title>
  </ion-card-header>

  <ion-list>
    <ion-radio-group value="{{transportFrom}}" (ionChange)="handleTransportFromChange($event)">  
          <ion-item>
            <ion-label>Van Collect</ion-label>
            <ion-radio value="Van Collect"></ion-radio>
          </ion-item>
      
          <ion-item>
            <ion-label>Cust Collect</ion-label>
            <ion-radio value="Cust Collect"></ion-radio>
          </ion-item>
      
          <ion-item>
            <ion-label>DPD Collect</ion-label>
            <ion-radio value="DPD Collect"></ion-radio>
          </ion-item>
      
    </ion-radio-group>
      
    <ion-radio-group value="{{transportTo}}" (ionChange)="handleTransportToChange($event)">  
      <ion-item>
        <ion-label>Van Deliver</ion-label>
        <ion-radio value="Van Deliver"></ion-radio>
      </ion-item>
  
      <ion-item>
        <ion-label>Cust Deliver</ion-label>
        <ion-radio value="Cust Deliver"></ion-radio>
      </ion-item>
  
      <ion-item>
        <ion-label>DPD Deliver</ion-label>
        <ion-radio value="DPD Deliver"></ion-radio>
      </ion-item>
  
</ion-radio-group>


  </ion-list>  
</ion-card>